import { render, staticRenderFns } from "./relatedmatter.vue?vue&type=template&id=5a853477&scoped=true&"
import script from "./relatedmatter.vue?vue&type=script&lang=js&"
export * from "./relatedmatter.vue?vue&type=script&lang=js&"
import style0 from "./relatedmatter.vue?vue&type=style&index=0&id=5a853477&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a853477",
  null
  
)

export default component.exports